
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 4h6c1.093 0 2 .907 2 2v12c0 1.093-.907 2-2 2h-6c-1.093 0-2-.907-2-2V6c0-1.093.907-2 2-2zm0 2v12h6V6h-6zm-6 8h2v4c0 2.22 1.78 4 4 4h6c2.22 0 4-1.78 4-4v-4h2v4c0 3.302-2.698 6-6 6h-2v2h4v2H11v-2h4v-2h-2c-3.302 0-6-2.698-6-6v-4z"}})])
          )
        }
      }
    